export default {"src":"/_next/static/media/Twiter2.123123db.svg","height":24,"width":26,"blurWidth":0,"blurHeight":0};